// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"738339c4","197":"5d1220f5","493":"3838317c","576":"91ba510a","611":"d82fe6a9","668":"9e0a4270","833":"66995b2c","976":"a3b6ad24"}[chunkId] + ".chunk.css";
};